// extracted by mini-css-extract-plugin
module.exports = {"loader_color":"#FFB300","loader_size":"200","iconsSvg_color":"#26262C","iconSvgNeu_color":"#dc1e16"};